"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TabItem = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tab = require("./Tab.style");

var _excluded = ["children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Tab = function Tab(_ref) {
  var variant = _ref.variant,
      children = _ref.children,
      activeTab = _ref.activeTab,
      onChange = _ref.onChange,
      itemProps = _ref.itemProps,
      className = _ref.className,
      color = _ref.color,
      type = _ref.type,
      rhsContent = _ref.rhsContent,
      pl = _ref.pl,
      pr = _ref.pr;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      tabs = _useState2[0],
      setTabs = _useState2[1];

  var _useState3 = (0, _react.useState)(activeTab || 0),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      activeIndex = _useState4[0],
      setActiveIndex = _useState4[1];

  var elements = (0, _react.useMemo)(function () {
    return _react["default"].Children.toArray(children).filter(function (el) {
      return (0, _typeof2["default"])(el.type);
    });
  }, [children]);

  var Content = /*#__PURE__*/_react["default"].cloneElement(elements[activeIndex], {
    title: ''
  });

  var handleTabChange = function handleTabChange(event, index) {
    setActiveIndex(index);
    typeof onChange === 'function' && onChange(event, index);
  };

  (0, _react.useEffect)(function () {
    if (!isNaN(activeTab)) {
      setActiveIndex(activeTab);
    }
  }, [activeTab]);
  (0, _react.useEffect)(function () {
    var tabs = elements.map(function (ele, i) {
      ele.props.active && typeof ele.props.active === 'boolean' && setActiveIndex(i);
      return {
        id: i,
        title: ele.props.title,
        disabled: ele.props.disabled,
        startIcon: ele.props.startIcon,
        endIcon: ele.props.endIcon
      };
    });
    setTabs(tabs);
  }, [elements]);
  return /*#__PURE__*/_react["default"].createElement(_Tab.StyledTabContainer, {
    variant: variant,
    className: className,
    type: type
  }, /*#__PURE__*/_react["default"].createElement(_Tab.TabNavigation, {
    variant: variant,
    className: "eui-tab-nav",
    type: type,
    pl: pl,
    pr: pr
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "eui-tab-left"
  }, tabs.length > 0 && tabs.map(function (tab, i) {
    return /*#__PURE__*/_react["default"].createElement(_Tab.StyledTabItem, (0, _extends2["default"])({
      key: "tab-item-".concat(i),
      onClick: function onClick(event) {
        return handleTabChange(event, i);
      },
      active: activeIndex === i ? true : false,
      variant: variant,
      type: type,
      disabled: tab.disabled,
      color: color,
      hasIconLeft: !!tab.startIcon,
      hasIconRight: !!tab.endIcon,
      hasTitle: !!tab.title
    }, itemProps), tab.startIcon && /*#__PURE__*/_react["default"].createElement(_Tab.StyledIcon, {
      hasIconLeft: !!tab.startIcon,
      hasTitle: !!tab.title,
      active: activeIndex === i ? true : false
    }, tab.startIcon && tab.startIcon), /*#__PURE__*/_react["default"].createElement("span", {
      className: "t-text"
    }, tab.title), tab.endIcon && /*#__PURE__*/_react["default"].createElement(_Tab.StyledIcon, {
      hasIconRight: !!tab.endIcon,
      hasTitle: !!tab.title,
      active: activeIndex === i ? true : false
    }, tab.endIcon && tab.endIcon));
  })), rhsContent && /*#__PURE__*/_react["default"].createElement("div", {
    className: "eui-tab-right"
  }, rhsContent)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "eui-tab-content"
  }, Content));
};

var TabItem = function TabItem(_ref2) {
  var children = _ref2.children,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", props, children);
};

exports.TabItem = TabItem;
TabItem.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
};
Tab.propTypes = {
  variant: _propTypes["default"].oneOf(['horizontal']),
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].element), _propTypes["default"].element]),

  /**
   * (event, index) => {}
   */
  onChange: _propTypes["default"].func,
  className: _propTypes["default"].string,
  activeTab: _propTypes["default"].number,
  itemProps: _propTypes["default"].object,
  color: _propTypes["default"].oneOf(['primary']),
  type: _propTypes["default"].oneOf(['default', 'grouped']),
  rhsContent: _propTypes["default"].node,
  pl: _propTypes["default"].string,
  pr: _propTypes["default"].string
};
Tab.defaultProps = {
  variant: 'horizontal',
  color: 'primary',
  type: 'default'
};
var _default = Tab;
exports["default"] = _default;